import { Box, Chip, Typography } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import { HMIField } from '../../types';

const BOOL_COLOR = { on: '#2E7D32', off: '#9E9E9E' };

function formatNumber(value: unknown, decimals?: number): string {
  if (typeof value !== 'number' || Number.isNaN(value)) return '--';
  return value.toFixed(decimals ?? 1);
}

export interface IndicatorFieldProps {
  field: HMIField;
  value: unknown;
}

/** Read-only display for `kind: "indicator"` fields (and read-only actions). */
function IndicatorField({ field, value }: IndicatorFieldProps) {
  if (field.access === 'derived' && (value === undefined || value === '')) {
    return (
      <Typography variant="body2" color="text.secondary" title="Computed by device firmware">
        &mdash;
      </Typography>
    );
  }

  if (field.datatype === 'bool') {
    const isOn = Boolean(value);
    return (
      <Box display="flex" alignItems="center" gap={0.75}>
        <CircleIcon
          sx={{ fontSize: 14, color: isOn ? BOOL_COLOR.on : BOOL_COLOR.off }}
        />
        <Typography variant="body2">{isOn ? 'Yes' : 'No'}</Typography>
      </Box>
    );
  }

  if (field.datatype === 'enum' || field.datatype === 'string') {
    return <Chip size="small" label={String(value ?? '--')} />;
  }

  // numeric indicator
  return (
    <Typography variant="body2" fontWeight={600} color="success.main">
      {formatNumber(value, field.decimals)}
      {field.unit ? ` ${field.unit}` : ''}
    </Typography>
  );
}

export default IndicatorField;
